import React, {Component} from 'react';
import {NavLink} from 'react-router-dom';

export default class NewManualButton extends Component {
    render() {
        return (
            <NavLink className='btn btn-primary mb-3' to={`/customer/${this.props.id}/templates/new`}>
                Neue Mustervorlage
            </NavLink>
        )
    }
}